import { useCallback, useEffect, useRef } from 'react'

import { getCustomCssPreviewChannelName, getCustomCssPreviewStorageKey } from '~/portal/utils/shared/customCssPreview'

export const CUSTOM_CSS_PREVIEW_CLEARED = '__cleared__'

export const useCustomCssPreviewSync = (portalSubdomain: string): { syncDraft: (scopedCss: string) => void, clearDraft: () => void } => {
  const channelRef = useRef<BroadcastChannel | null>(null)

  useEffect(() => {
    const channel = new BroadcastChannel(getCustomCssPreviewChannelName(portalSubdomain))
    channelRef.current = channel
    return () => channel.close()
  }, [portalSubdomain])

  const syncDraft = useCallback((scopedCss: string): void => {
    localStorage.setItem(getCustomCssPreviewStorageKey(portalSubdomain), scopedCss)
    channelRef.current?.postMessage(scopedCss)
  }, [portalSubdomain])

  const clearDraft = useCallback((): void => {
    localStorage.removeItem(getCustomCssPreviewStorageKey(portalSubdomain))
    channelRef.current?.postMessage(CUSTOM_CSS_PREVIEW_CLEARED)
  }, [portalSubdomain])

  return { syncDraft, clearDraft }
}
